import React from 'react';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import style from './FullInfoBtn.module.scss';

interface IProps {
	onClick: () => void;
}

export const FullInfoBtn: React.FC<IProps> = ({ onClick }) => {
	return (
		<Button className={style.btn} onClick={onClick}>
			<Text translationNameSpace="listing" translationKey="fullInfoButton" asFragment={true} />
		</Button>
	);
};
